import React from 'react';
import { getAuthenticated } from 'stores/useAuthStore';


export function RouteContentSkeleton() {
  return (
    <div className="route-content-skeleton" aria-hidden="true">
      <div className="skeleton-block route-content-skeleton__bar" />
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          className="skeleton-block route-content-skeleton__row"
        />
      ))}
    </div>
  );
}

export function AuthenticatedRouteContentSkeleton() {
  return getAuthenticated() ? <RouteContentSkeleton /> : null;
}

export function AppShellSkeleton() {
  return (
    <div className="app-shell-skeleton" aria-hidden="true">
      <div className="app-shell-skeleton__topbar" />
      <div className="app-shell-skeleton__sidebar">
        {Array.from({ length: 6 }).map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i} className="skeleton-block" />
        ))}
      </div>
      <div style={{ marginLeft: 64, paddingTop: 50 }}>
        <RouteContentSkeleton />
      </div>
    </div>
  );
}
